import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PhotoLibraryRoundedIcon from "@mui/icons-material/PhotoLibraryRounded";

export default function GalleryFormDialog({
  open,
  onClose,
  onSubmit,
  initialData,
  loading,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [name, setName] = useState("");

  useEffect(() => {
    if (!open) return;

    if (initialData) {
      setName(initialData.name || "");
    } else {
      setName("");
    }
  }, [initialData, open]);

  const handleSave = () => {
    const cleanName = name.trim();
    if (!cleanName) return;
    onSubmit({ name: cleanName });
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "primary.main",
          color: "#fff",
          px: 2.5,
          py: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box>
            <Typography sx={{ fontWeight: 700, fontSize: "1.05rem", color: "#fff" }}>
              {initialData ? "Editar galería" : "Nueva galería"}
            </Typography>
            <Typography
              sx={{
                fontSize: "0.84rem",
                color: "rgba(255,255,255,0.88)",
                fontWeight: 500,
              }}
            >
              {initialData
                ? "Actualiza el nombre de la galería seleccionada"
                : "Crea una nueva galería para organizar tus imágenes"}
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <TextField
          autoFocus
          fullWidth
          label="Nombre de la galería"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ mt: 2 }}
          placeholder="Ejemplo: Premiación, Inauguración, Clausura"
        />
      </DialogContent>

      <DialogActions
        sx={{
          px: 3,
          pb: 2.5,
          gap: 1,
        }}
      >
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Cancelar
        </Button>

        <Button
          onClick={handleSave}
          variant="contained"
          disabled={loading || !name.trim()}
        >
          {loading
            ? "Guardando..."
            : initialData
            ? "Actualizar"
            : "Crear"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}